import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import img from "../../../images/Frame 1321316343.png"
import { NavLink } from "react-router-dom";
const RecentBlogs = ({ data }) => {
    return (
        <div >
            {
                data?.map(ele => {
                    return (
                        <NavLink
                        key={ele.id}
                        className="textdecoration-none"
                        to={`/blog/${ele.url}/${ele.id}`}>
                        <Row className="blog-maindetails">
                            <Col lg={6} md={6} sm={6} xs={6} >
                                <img  className="blogmain-img" src={ele.image}></img>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={6} >
                            <div className="blogdate">
                                                {(() => {
                                                    const date = new Date(ele.display_date);
                                                    const day = String(date.getDate()).padStart(2, '0');
                                                    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                                                    const year = date.getFullYear();
                                                    return `${day}-${month}-${year}`;
                                                })()}
                                            </div>
                                <div className="mobileblogtitle">{ele.title}</div>
                            </Col>

                        </Row>
                        </NavLink>
                    )
                })
            }

        </div>
    )
}
export default RecentBlogs;